'use client';

import { ArrowCounterClockwise } from '@phosphor-icons/react';
import { LegalPageLayout } from '@/components/legal/legal-page-layout';

const Highlight = ({ children }: { children: React.ReactNode }) => (
  <div className="p-4 rounded-card bg-[var(--primary-subtle)] text-[var(--text-primary)] text-sm">
    {children}
  </div>
);

export function RefundContent() {
  const sections = [
    {
      title: 'Общие условия возврата',
      content: (
        <p>Возврат наличными денежными средствами при оплате картой не допускается. Порядок возврата регулируется правилами международных платёжных систем.</p>
      ),
    },
    {
      title: 'Порядок возврата',
      content: (
        <>
          <p>Для возврата денежных средств на банковскую карту заказчику необходимо обратиться в Call-центр и предоставить номер карты, с которой производилась оплата заказа.</p>
          <Highlight>
            <p>Возврат денежных средств будет осуществлён на банковский счёт заказчика в течение 21 (двадцати одного) рабочего дня со дня получения заявки.</p>
          </Highlight>
        </>
      ),
    },
  ];

  return (
    <LegalPageLayout
      title="Политика возврата"
      icon={<ArrowCounterClockwise className="w-3.5 h-3.5 text-[var(--primary)]" weight="fill" />}
      sections={sections}
      breadcrumbs={[
        { name: 'Главная', href: '/' },
        { name: 'Политика возврата', href: '/refund' },
      ]}
      contactBlock={
        <div className="text-sm text-[var(--text-secondary)] space-y-1">
          <p>Для оформления возврата свяжитесь с нами:</p>
          <a href="tel:+78633335050" className="block text-[var(--primary)] font-medium hover:underline">+7 (863) 333-50-50 (Ростов-на-Дону)</a>
        </div>
      }
    />
  );
}
